<template>
    <div class="section_container">
        <h1 class="section_title">ABOUT</h1>

        <div class="content_container">
            <div class="content_split">
                <img class="profile_pic" src="https://avatars.githubusercontent.com/u/63126840?v=4" />

                <div class="content">
                    <p>
                        Hello! I'm Jacopo, a computer science graduate from Colorado State University, specializing in 
                        software engineering. Alongside my academic work, I take on contract and commission-based web development 
                        projects, while also actively maintaining my own professional tools and creative experiments.

                        <br><br>
                        
                        My skill set bridges both front-end and back-end technologies, with additional experience in lower-level 
                        programming using languages like Java, C, and C++. Over the years, I've contributed to a range of impactful 
                        academic and personal projects, sharpening not only my technical expertise but also my ability to collaborate, 
                        iterate, and build with purpose.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

@import "../../assets/css/titles.css";

@media screen and (max-width: 1000px) {
    .content_split {
        flex-direction: column;
    }
    .profile_pic {
        margin: 0px auto 50px auto;
    }
}
@media screen and (max-width: 750px) {
    .section_container {
        padding: 125px 5px 10px 5px !important;
    }
    .content p {
        padding: 0px 20px 0px 20px !important;
    }
}
.section_container {
    padding: 100px;
    max-width: 1100px;
    margin: 0 auto;
}
.content_container {
    display: flex;
    flex-direction: column;
    margin-top: 100px;
}
.content_split { 
    display: flex;
}
.content_split div {
    display: flex;
    flex-direction: column;
}
.content p {
    font-size: 20px;
    letter-spacing: 0.5px;
    text-align: left;
    padding: 0px 50px 0px 50px;
    line-height: 32px;
    font-weight: 100;
}
.profile_pic {
    width: 300px;
    height: 300px;
    border-radius: 50%;
}

</style>